import React, { useEffect, useState } from "react";
import {
  Grid,
  ActionIcon,
  Title,
  Card,
  Text,
  Loader,
  Accordion,
} from "@mantine/core";
import { apiWithInterceptor } from "../../../../api";
import { useParams } from "react-router-dom";

const TheaterSectionsGrid = () => {
  const { theaterID } = useParams();
  const [theater, setTheater] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    apiWithInterceptor
      .get(`/theater/${theaterID}?relations[]=sections.rows.seats`)
      .then((response) => {
        setTheater(response.data);
        setLoading(false);
      });
  }, []);
  return (
    <>
      {loading ? (
        <Grid
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid.Col
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader color="yellow" size="xl" />
          </Grid.Col>
        </Grid>
      ) : (
        <Grid
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Grid.Col
            xs={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Title order={1}>{theater.name}</Title>
          </Grid.Col>

          {theater.sections?.map((section) => (
            <Grid.Col>
              <Accordion>
                <Card
                  shadow="sm"
                  radius="md"
                  withBorder
                  key={section.id}
                  style={{
                    height: "auto",
                  }}
                >
                  <Accordion.Item value={section.name} sx={{ border: 0 }}>
                    <Accordion.Control>
                      <Grid.Col
                        style={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <Title
                          style={{
                            padding: "10px",
                          }}
                          order={2}
                        >
                          {section.name} Section
                        </Title>
                        <Text
                          variant="gradient"
                          gradient={
                            section.vip
                              ? { from: "green", to: "cyan", deg: 45 }
                              : { from: "red", to: "pink", deg: 45 }
                          }
                          sx={{ fontFamily: "Greycliff CF, sans-serif" }}
                          ta="center"
                          fz="xs"
                          fw={700}
                        >
                          {section.vip ? "VIP" : "STD"}
                        </Text>
                      </Grid.Col>
                    </Accordion.Control>
                    <Accordion.Panel>
                      <Card.Section>
                        {section.rows?.map((row) => (
                          <>
                            <Card
                              withBorder
                              shadow="sm"
                              radius="xl"
                              mb="md"
                              key={row.id}
                            >
                              <Grid>
                                <Grid.Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Title
                                    style={{
                                      borderRight: "1px solid gray",
                                      padding: "2px",
                                      color: "gray",
                                    }}
                                    order={6}
                                  >
                                    Row {row.name.toUpperCase()}
                                  </Title>
                                </Grid.Col>
                                <Grid.Col
                                  xs={10}
                                  md={10}
                                  lg={10}
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    overflow: "scroll",
                                  }}
                                >
                                  {row.seats?.map((seat, index) => (
                                    <ActionIcon
                                      style={{ width: "45px", height: "45px" }}
                                      key={seat.id}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="icon icon-tabler icon-tabler-armchair"
                                        width="100%"
                                        height="100%"
                                        color="green"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1}
                                        stroke="currentColor"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <path
                                          stroke="none"
                                          d="M0 0h24v24H0z"
                                          fill="none"
                                        />
                                        <path d="M5 11a2 2 0 0 1 2 2v2h10v-2a2 2 0 1 1 4 0v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z"></path>
                                        <path d="M5 11v-5a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v5"></path>
                                        <path d="M6 19v2"></path>
                                        <path d="M18 19v2"></path>
                                        <text
                                          x="50%"
                                          y="50%"
                                          dy="-1.5"
                                          dominantBaseline="middle"
                                          textAnchor="middle"
                                          fontSize={"8px"}
                                          fontWeight={50}
                                        >
                                          {index + 1}
                                        </text>
                                      </svg>
                                    </ActionIcon>
                                  ))}
                                </Grid.Col>
                                <Grid.Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Title
                                    style={{
                                      borderLeft: "1px solid gray",
                                      padding: "2px",
                                      color: "gray",
                                    }}
                                    order={6}
                                  >
                                    Total {row.seats.length}
                                  </Title>
                                </Grid.Col>
                              </Grid>
                            </Card>
                          </>
                        ))}
                      </Card.Section>
                    </Accordion.Panel>
                  </Accordion.Item>
                </Card>
              </Accordion>
            </Grid.Col>
          ))}
        </Grid>
      )}
    </>
  );
};

export default TheaterSectionsGrid;
